
import React, { useEffect, useState } from "react";
import "./Schedule_manager.css";

const API_URL = process.env.REACT_APP_API_FAST || "";

const DEFAULT_SETTINGS = {
  enabled: false,
  start_time: "08:00",
  timezone: "Africa/Nairobi",
  wait_hours: 1,
  wait_minutes: 0,
};

export function Schedule_manager() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [savedSettings, setSavedSettings] = useState(DEFAULT_SETTINGS);
  console.log("schedule_data",savedSettings)

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [creatingDefaults, setCreatingDefaults] = useState(false);
  const [settingsMissing, setSettingsMissing] = useState(false);

  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const settingsUrl = `${API_URL}/workflow/settings/scheduler`;
  const defaultsUrl = `${settingsUrl}/defaults`;

  // Convert API values into the types expected by the form.
  const normalizeSettings = (data) => ({
    enabled: data.enabled ?? DEFAULT_SETTINGS.enabled,
    start_time: String(
      data.start_time ?? DEFAULT_SETTINGS.start_time
    ).slice(0, 5),
    timezone: data.timezone ?? DEFAULT_SETTINGS.timezone,
    wait_hours: Number(
      data.wait_hours ?? DEFAULT_SETTINGS.wait_hours
    ),
    wait_minutes: Number(
      data.wait_minutes ?? DEFAULT_SETTINGS.wait_minutes
    ),
    next_run: data.next_run ?? null
  });

  // Load existing scheduler settings from FastAPI.
  // Returns true when loading succeeds and false otherwise.
  const loadSettings = async (showLoading = true) => {
    if (showLoading) {
      setLoading(true);
    }

    setError("");
    setMessage("");
    setSettingsMissing(false);

    try {
      const response = await fetch(settingsUrl);

      if (!response.ok) {
        const detail = await response.text();

        if (
          detail.toLowerCase().includes("no scheduler settings found")
        ) {
          setSettingsMissing(true);
          return false;
        }

        throw new Error(
          detail || `Could not load settings (${response.status}).`
        );
      }

      const data = await response.json();
      console.log("fill_data_is",data)
      const loaded = normalizeSettings(data);

      setSettings(loaded);
      setSavedSettings(loaded);
      setSettingsMissing(false);

      return true;
    } catch (err) {
      setError(
        `${err.message} Check that the FastAPI settings endpoint is available.`
      );
      return false;
    } finally {
      if (showLoading) {
        setLoading(false);
      }
    }
  };

  // Load settings when the component first mounts.

useEffect(() => {
  let cancelled = false;

  const initialLoad = async () => {
    if (cancelled) return;

    await loadSettings();
  };

  initialLoad();

  return () => {
    cancelled = true;
  };
}, [settingsUrl]); 


  // Update an individual field when the user edits the form.
  const updateSetting = (name, value) => {
    setSettings((current) => ({
      ...current,
      [name]: value,
    }));

    setMessage("");
    setError("");
  };

  // Determine whether the form differs from the saved configuration.
  const hasChanges =
    JSON.stringify(settings) !== JSON.stringify(savedSettings);

  // Create the initial database row through the FastAPI POST endpoint.
  const createDefaultSettings = async () => {
    setCreatingDefaults(true);
    setError("");
    setMessage("");

    try {
      const response = await fetch(defaultsUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          data.detail ||
            `Could not create default settings (${response.status}).`
        );
      }

      // Reload and verify the row actually exists.
      const loaded = await loadSettings(false);

      if (!loaded) {
        throw new Error(
          "The defaults endpoint responded, but the settings could not be loaded. Check the FastAPI endpoint and database."
        );
      }

      setMessage(
        data.message ||
          "Default scheduler settings created successfully."
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setCreatingDefaults(false);
    }
  };

  // Save changes to an existing scheduler settings row.
  const saveSettings = async (event) => {
    event.preventDefault();

    setSaving(true);
    setError("");
    setMessage("");

    try {
      const payload = {
        ...settings,
        wait_hours: Number(settings.wait_hours),
        wait_minutes: Number(settings.wait_minutes),
      };
        const settingsUrl_update = `${API_URL}/workflow/settings/scheduler/update`;
      const response = await fetch(settingsUrl_update, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          data.detail || `Save failed (${response.status}).`
        );
      }

      const saved = normalizeSettings({
        ...payload,
        ...data,
      });

      setSettings(saved);
      setSavedSettings(saved);
      setMessage("Schedule settings saved successfully.");
    } catch (err) {
      setError(
        `${err.message} Check that the FastAPI PUT endpoint is available.`
      );
    } finally {
      setSaving(false);
    }
  };

  // Restore the last successfully saved values.
  const resetChanges = () => {
    setSettings(savedSettings);
    setError("");
    setMessage("");
  };

  const totalWaitMinutes =
    Number(settings.wait_hours || 0) * 60 +
    Number(settings.wait_minutes || 0);

  return (
    <main className="schedule-manager">
      <header className="schedule-header">
        <div>
          <div className="schedule-eyebrow">
            <span className="schedule-eyebrow-dot" />
            AUTOMATION CONTROL
          </div>

          <h1>Schedule Manager</h1>

          <p>
      next schedule_in:{" "}
<strong>
  {settings.next_run
    ? new Date(settings.next_run).toLocaleString("en-KE", {
        timeZone: "Africa/Nairobi",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
    : "--"}
</strong>--
            Control when your master workflow starts and when the next
            cycle runs after completion.        

          </p>
          
        
  

        </div>
      
        <div
          className={`schedule-status ${
            settings.enabled ? "is-enabled" : "is-disabled"
          }`}
        >
          <span className="schedule-status-dot" />
          {settings.enabled
            ? "Automation enabled"
            : "Automation disabled"}
        </div>
      </header>

      {error && (
        <div
          className="schedule-alert schedule-alert-error"
          role="alert"
        >
          <span>!</span>
          <div>{error}</div>
        </div>
      )}

      {message && (
        <div
          className="schedule-alert schedule-alert-success"
          role="status"
        >
          <span>✓</span>
          <div>{message}</div>
        </div>
      )}

      {/* Display initialization controls if no settings row exists. */}
      {settingsMissing && (
        <section className="schedule-panel">
          <div className="schedule-panel-heading">
            <div>
              <span className="schedule-section-number">00</span>
              <h2>Initialize scheduler settings</h2>
              <p>
                No initial settings row was found in workflow_scheduler.
                Create the default row to initialize the scheduler.
              </p>
            </div>
          </div>

          <div className="schedule-enabled-note">
            <span className="schedule-note-indicator" />
            <div>
              <strong>Safe default configuration</strong>
              <p>
                Automation will be created as disabled, with a start
                time of 08:00 Africa/Nairobi and a one-hour wait
                after completion.
              </p>
            </div>
          </div>

          <button
            type="button"
            className="schedule-button schedule-button-primary"
            onClick={createDefaultSettings}
            disabled={
              creatingDefaults || loading || saving
            }
          >
            {creatingDefaults
              ? "Creating defaults..."
              : "Create Default Settings"}
          </button>
        </section>
      )}

      <section className="schedule-summary-grid">
        <article className="schedule-summary-card">
          <div className="schedule-summary-icon icon-purple">◷</div>
          <div>
            <span className="schedule-summary-label">
              Initial start time
            </span>
            <strong>{settings.start_time || "--:--"}</strong>
            <small>{settings.timezone || "Africa/Nairobi"}</small>
          </div>
        </article>

        <article className="schedule-summary-card">
          <div className="schedule-summary-icon icon-blue">↻</div>
          <div>
            <span className="schedule-summary-label">
              Wait after completion
            </span>
            <strong>
              {totalWaitMinutes >= 60
                ? `${Math.floor(totalWaitMinutes / 60)}h ${
                    totalWaitMinutes % 60
                  }m`
                : `${totalWaitMinutes} min`}
            </strong>
            <small>Before the next cycle</small>
          </div>
        </article>

        <article className="schedule-summary-card">
          <div className="schedule-summary-icon icon-green">✓</div>
          <div>
            <span className="schedule-summary-label">
              Configuration
            </span>
            <strong>
              {settingsMissing
                ? "Not initialized"
                : hasChanges
                ? "Unsaved"
                : "Up to date"}
            </strong>
            <small>
              {settingsMissing
                ? "Create the initial settings row"
                : hasChanges
                ? "Save your changes"
                : "Current settings loaded"}
            </small>
          </div>
        </article>
      </section>

      <form onSubmit={saveSettings}>
        <section className="schedule-panel">
          <div className="schedule-panel-heading">
            <div>
              <span className="schedule-section-number">01</span>
              <h2>Automation settings</h2>
              <p>
                Choose whether the backend should run this workflow.
              </p>
            </div>

            <label className="schedule-toggle">
              <input
                type="checkbox"
                checked={settings.enabled}
                onChange={(event) =>
                  updateSetting("enabled", event.target.checked)
                }
                disabled={loading || saving || settingsMissing}
              />
              <span className="schedule-toggle-track" />
            </label>
          </div>

          <div className="schedule-enabled-note">
            <span className="schedule-note-indicator" />
            <div>
              <strong>
                {settings.enabled
                  ? "Automatic execution is enabled"
                  : "Automatic execution is paused"}
              </strong>
              <p>
                {settings.enabled
                  ? "The backend scheduler can start the workflow according to these saved settings."
                  : "Saving this setting as disabled should stop future automatic starts. It does not stop a workflow already running."}
              </p>
            </div>
          </div>
        </section>

        <section className="schedule-panel">
          <div className="schedule-panel-heading">
            <div>
              <span className="schedule-section-number">02</span>
              <h2>Start configuration</h2>
              <p>
                Set the first daily start time for the workflow cycle.
              </p>
            </div>

            <span className="schedule-mini-badge">LOCAL TIME</span>
          </div>

          <div className="schedule-fields">
            <div className="schedule-field">
              <label htmlFor="workflow-start-time">
                Initial start time
              </label>

              <input
                id="workflow-start-time"
                type="time"
                value={settings.start_time}
                onChange={(event) =>
                  updateSetting("start_time", event.target.value)
                }
                required
                disabled={loading || saving || settingsMissing}
              />

              <small>The first cycle starts at this time.</small>
            </div>

            <div className="schedule-field">
              <label htmlFor="workflow-timezone">Time zone</label>

              <select
                id="workflow-timezone"
                value={settings.timezone}
                onChange={(event) =>
                  updateSetting("timezone", event.target.value)
                }
                disabled={loading || saving || settingsMissing}
              >
                <option value="Africa/Nairobi">
                  Africa/Nairobi (EAT)
                </option>
                <option value="UTC">UTC</option>
              </select>

              <small>Used to interpret the initial start time.</small>
            </div>
          </div>
        </section>

        <section className="schedule-panel">
          <div className="schedule-panel-heading">
            <div>
              <span className="schedule-section-number">03</span>
              <h2>Repeat after completion</h2>
              <p>
                The waiting period starts only after every operation in
                the master workflow has finished.
              </p>
            </div>
          </div>

          <div className="schedule-fields">
            <div className="schedule-field">
              <label htmlFor="workflow-wait-hours">Wait hours</label>

              <input
                id="workflow-wait-hours"
                type="number"
                min="0"
                max="168"
                step="1"
                value={settings.wait_hours}
                onChange={(event) =>
                  updateSetting(
                    "wait_hours",
                    event.target.value === ""
                      ? ""
                      : Math.max(
                          0,
                          Math.min(168, Number(event.target.value))
                        )
                  )
                }
                onBlur={() =>
                  updateSetting(
                    "wait_hours",
                    settings.wait_hours === ""
                      ? 0
                      : settings.wait_hours
                  )
                }
                required
                disabled={loading || saving || settingsMissing}
              />
            </div>

            <div className="schedule-field">
              <label htmlFor="workflow-wait-minutes">
                Wait minutes
              </label>

              <input
                id="workflow-wait-minutes"
                type="number"
                min="0"
                max="59"
                step="1"
                value={settings.wait_minutes}
                onChange={(event) =>
                  updateSetting(
                    "wait_minutes",
                    event.target.value === ""
                      ? ""
                      : Math.max(
                          0,
                          Math.min(59, Number(event.target.value))
                        )
                  )
                }
                onBlur={() =>
                  updateSetting(
                    "wait_minutes",
                    settings.wait_minutes === ""
                      ? 0
                      : settings.wait_minutes
                  )
                }
                required
                disabled={loading || saving || settingsMissing}
              />
            </div>
          </div>

          <div className="schedule-cycle-preview">
            <div className="schedule-cycle-icon">↻</div>
            <div>
              <strong>How your cycle will run</strong>
              <p>
                Start at {settings.start_time || "--:--"}, execute
                operations in order, wait {totalWaitMinutes} minute(s)
                after completion, then start the next cycle.
              </p>
            </div>
          </div>
        </section>

        <footer className="schedule-footer">
          <div className="schedule-save-info">
            {loading
              ? "Loading saved settings..."
              : settingsMissing
              ? "Create default settings before editing."
              : hasChanges
              ? "You have unsaved changes."
              : "Your form matches the saved configuration."}
          </div>

          <div className="schedule-footer-actions">
            <button
              type="button"
              className="schedule-button schedule-button-secondary"
              onClick={resetChanges}
              disabled={
                !hasChanges ||
                saving ||
                loading ||
                settingsMissing
              }
            >
              Discard changes
            </button>

            <button
              type="submit"
              className="schedule-button schedule-button-primary"
              disabled={
                loading ||
                saving ||
                creatingDefaults ||
                settingsMissing ||
                !hasChanges
              }
            >
              {saving ? "Saving..." : "Save schedule"}
            </button>
          </div>
        </footer>
      </form>
    </main>
  );
}

export default Schedule_manager;
